export default __webpack_public_path__ + "static/PB-logo-bfbe8643ac6f6b5d1a5eb510f73cf9ee.svg";